import { render } from "./ShopConfig.vue?vue&type=template&id=1edbebc8&scoped=true"
import script from "./ShopConfig.vue?vue&type=script&lang=js"
export * from "./ShopConfig.vue?vue&type=script&lang=js"

import "./ShopConfig.vue?vue&type=style&index=0&id=1edbebc8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1edbebc8"]])

export default __exports__